import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Grain from "@/components/Grain";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Ribbon from "@/components/Ribbon";
import Notices from "@/components/Notices";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App" data-testid="azzaro-app">
      <Grain />
      <SmoothScroll>
        <Header />
        <main>
          <Hero />
          <Ribbon />
          <Contact />
          <Notices />
        </main>
        <Footer />
      </SmoothScroll>
    </div>
  );
}

export default App;
